import { createReducer } from 'pobble-components/dist/redux-helpers'
import { combineReducers } from 'redux'
import findIndex from 'lodash/findIndex'

let defaultState = {
  activeSlideId: null,
  isDragging: false,
  settingsModalOpened: false,
  createSlideDialog: {
    opened: false
  },
  editSlideDialog: {
    opened: false
  },
  editDialog: {
    opened: false
  }
}

const closeSettingsModal = state => ({ ...state, settingsModalOpened: false })

const Builder = createReducer(defaultState, {
  'BUILDER:SET_ACTIVE_SLIDE': (state, { id }) => ({
    ...state,
    activeSlideId: id
  }),
  'PRESENT:SET_ACTIVE_SLIDE': (state, { id }) => ({
    ...state,
    activeSlideId: id
  }),
  'PRESENTATION:CREATE_SLIDE_REQUEST_SUCCESS': (state, { response }) => ({
    ...state,
    activeSlideId: response.data.slide.id,
    createSlideDialog: {
      ...state.createSlideDialog,
      opened: false
    }
  }),
  'PRESENTATION:DELETE_SLIDE_REQUEST_SUCCESS': (state, { params }) => ({
    ...state,
    activeSlideId:
      params.slides[findIndex(params.slides, { id: params.id }) - 1].id
  }),
  'BUILDER:SET_PREVIEW_DRAGGING': (state, { isDragging }) => ({
    ...state,
    isDragging
  }),
  'PRESENTATION:ADD_ASSET': (state, { order, slides }) => ({
    ...state,
    activeSlideId: slides[order].id
  }),
  'PRESENTATION:FETCH_REQUEST_SUCCESS': (state, { response, params }) => {
    return {
      ...state,
      activeSlideId: response.data.presentation.slides.filter(
        slide => slide.id === state.activeSlideId
      ).length
        ? state.activeSlideId
        : params.activeSlideId
          ? params.activeSlideId
          : params.showLastSlide
            ? response.data.presentation.slides[
                response.data.presentation.slides.length - 1
              ].id
            : response.data.presentation.asset
              ? response.data.presentation.slides[
                  response.data.presentation.slides.length - 1
                ].id
              : response.data.presentation.slides[0].id
    }
  },
  'PRESENTATION:REORDER_SLIDES_REQUEST': state => ({
    ...state,
    isDragging: false
  }),
  'BUILDER:OPEN_SETTINGS_MODAL': state => ({
    ...state,
    settingsModalOpened: true
  }),
  'BUILDER:CLOSE_SETTINGS_MODAL': closeSettingsModal,
  'PRESENTATION:UPDATE_PROPERTIES_REQUEST_SUCCESS': closeSettingsModal,
  'PRESENTATION:UPDATE_PROPERTIES_REQUEST_ERROR': closeSettingsModal,
  'BUILDER:OPEN_CREATE_SLIDE_DIALOG': (state, { slideType, slideParams }) => ({
    ...state,
    createSlideDialog: {
      opened: true,
      type: slideType,
      ...slideParams
    }
  }),
  'BUILDER:CLOSE_CREATE_SLIDE_DIALOG': state => ({
    ...state,
    createSlideDialog: {
      ...state.createSlideDialog,
      opened: false
    }
  }),
  'BUILDER:OPEN_EDIT_SLIDE_DIALOG': (
    state,
    { slideType, slideId, slideParams }
  ) => ({
    ...state,
    editSlideDialog: {
      opened: true,
      type: slideType,
      slideId,
      ...slideParams
    }
  }),
  'BUILDER:CLOSE_EDIT_SLIDE_DIALOG': state => ({
    ...state,
    editSlideDialog: {
      ...state.editSlideDialog,
      opened: false
    }
  }),
  'PRESENTATION:UPDATE_SLIDE_REQUEST_SUCCESS': state => ({
    ...state,
    editSlideDialog: {
      ...state.editSlideDialog,
      opened: false
    }
  })
})

const Combined = combineReducers({
  Main: Builder
})

export default Combined
